var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocPpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 71,
    viewBox: "0 0 72 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_810_5267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0527 6.19841V64.8016C18.0527 68.2249 20.7845 71 24.1543 71H65.2012C68.571 71 71.3027 68.2249 71.3027 64.8016V16.3106C71.3027 14.6549 70.6506 13.068 69.4918 11.9037L59.4276 1.79145C58.2853 0.643726 56.7435 0 55.1369 0H24.1543C20.7845 0 18.0527 2.77512 18.0527 6.19841ZM21.9355 64.8016V6.19841C21.9355 4.95358 22.9289 3.94444 24.1543 3.94444H54.3848V17.4683C54.3848 19.8023 56.2473 21.6944 58.5449 21.6944H67.4199V64.8016C67.4199 66.0464 66.4266 67.0556 65.2012 67.0556H24.1543C22.9289 67.0556 21.9355 66.0464 21.9355 64.8016ZM67.4199 17.75V16.3106C67.4199 15.7085 67.1828 15.1315 66.7614 14.7081L58.2676 6.17377V17.4683C58.2676 17.6239 58.3917 17.75 58.5449 17.75H67.4199Z",
    fill: "#9D9C9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6777 53.25C53.5527 53.25 57.9902 48.8125 57.9902 39.9375H49.1152V31.0625H44.6777V39.9375V53.25Z",
    fill: "#E48762"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5527 35.5V26.625C56.8809 26.625 62.4277 32.1719 62.4277 35.5H53.5527Z",
    fill: "#F9D4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.302734 20.5234C0.302734 18.6854 1.79279 17.1953 3.63086 17.1953H36.9121C38.7502 17.1953 40.2402 18.6854 40.2402 20.5234V53.8047C40.2402 55.6428 38.7502 57.1328 36.9121 57.1328H3.63086C1.79279 57.1328 0.302734 55.6428 0.302734 53.8047V20.5234Z",
    fill: "#C25B33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6152 47.7508V25.5156H19.5305C21.7348 25.5156 23.1756 25.6218 23.8531 25.8341C24.935 26.1779 25.8249 26.911 26.5226 28.0334C27.2304 29.1558 27.5843 30.6017 27.5843 32.3712C27.5843 33.9789 27.2809 35.3288 26.6742 36.4209C26.0675 37.5028 25.3092 38.2662 24.3991 38.7111C23.4891 39.1459 21.9218 39.3633 19.6973 39.3633H17.2857V47.7508H13.6152ZM17.2857 29.2771V35.5867H19.3181C20.6832 35.5867 21.6084 35.4906 22.0937 35.2985C22.5892 35.1064 22.9936 34.7626 23.3071 34.2671C23.6206 33.7615 23.7773 33.1447 23.7773 32.4167C23.7773 31.6786 23.6155 31.0567 23.2919 30.5511C22.9684 30.0456 22.569 29.7068 22.0937 29.5349C21.6185 29.363 20.6124 29.2771 19.0754 29.2771H17.2857Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_810_5267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 71,
    fill: "white",
    transform: "translate(0.302734)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocPpt);
export default __webpack_public_path__ + "static/media/doc-ppt.00bba30fdb8cebfe9fd608623b0988cd.svg";
export { ForwardRef as ReactComponent };